import { uoUWidgetLoadOnLiveSiteSrc187Evid8 } from '@wix/bi-logger-bookings-data/v2';
import { queryServiceByFormId } from './api/query-service-by-form-id';
export const loadInitialAppointmentData = async (httpClient, errorHandler, _wixCodeApi, formId, _form, environment, bi, signal)=>{
    if (environment.isEditor) {
        return {};
    }
    bi?.report(uoUWidgetLoadOnLiveSiteSrc187Evid8({
        widgetName: 'appointment',
        environment: JSON.stringify(environment)
    }));
    const [service] = await Promise.all([
        queryServiceByFormId({
            httpClient,
            errorHandler,
            formId,
            signal
        })
    ]);
    return {
        service
    };
};

//# sourceMappingURL=load-initial-appointment-data.js.map